<!-- 设备保养记录 -->
<style>
	.baoyangxianginput {
		width: 1.25rem;
	}
</style>
<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/resume/pageMaintain"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="'true'" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('mujubianma/mingcheng')">
						<yi_cross_select disabled :selectTitle="'code,name'" multiple :component="'web_base_mould_list'"
							:ids.sync="$attrs.maintenanceRecord.mouldId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('dangnianleijibaoyangcishu')" label-width="230px">
						{{yt.total}}
					</el-form-item><br/>
					<el-form-item :label="$t('nianfen')">
						<yi_time_input format="yyyy" :type="'year'" :time.sync="yt.conditions.year" :clearable="false">
						</yi_time_input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1);setQueryParams()" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="reset()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 保养类型 -->
			<template #baoyangleixing="scope">
				<span v-if="scope.row.type===0">{{$t('shoucibaoyang')}}</span>
				<span v-if="scope.row.type===1">{{$t('dingqibaoyang')}}</span>
			</template>
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('baoyangxiang', scope.row,'70%')">
							{{$t('baoyangxiang')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button  v-if="scope.row.status!=3 && scope.row.mode==2" type="text" @click="yt.showEditDialog('bianji',scope.row,'w2')">{{$t('bianji')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 保养项 -->
			<template v-if="yt.editObj.action == 'baoyangxiang'">
				<div class="dialog-scroller">
					<maintenance_item :item="yt.editObj" ref="maintainRecordItem"></maintenance_item>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import maintenance_item from '@@/pages/web/mold_management/resume/maintenance_item'
	export default {
		name: 'web_mold_management_resume_maintenance_times',
		components: {
			maintenance_item
		},
		data() {
			return {
				leaveFactoryDate: (new Date()).getFullYear() + '-' + ((new Date()).getMonth() + 1) + '-' + (new Date())
					.getDate(),
				list: [],
				columns: [{
					label: 'mujubaoyangdanhao',
					prop: 'no',
					width: 150
				}, {
					label: 'baoyangleixing',
					prop: 'type',
					type: 'slot',
				},
				{
					label: 'baoyangzhuangtai',
					type: 'tag',
					prop: 'status',
					tags: {
						0: {
							color: '#F56C6C',
							text: this.$t('weibaoyang')
						},
						1: {
							color: '#E6A23C',
							text: this.$t('baoyangzhong')
						},
						2: {
							color: '#67C23A',
							text: this.$t('yiwancheng')
						}
					},
				}, {
					label: 'jihuabaoyangshijian',
					prop: 'planTime',
					type: 'time',
					width: 150,
					format: 'YYYY-MM-DD'
				}, {
					label: 'yujibaoyanghaoshi(xiaoshi)',
					prop: 'timeConsuming',
					// type: 'time',
					width: 180
					// format: 'yyyy-MM-dd:hh:mm:ss'
				},{
					label: 'baoyangkaishishijian',
					prop: 'startTime',
					type: 'time',
					width: 150
				}, {
					label: 'baoyangjieshushijian',
					prop: 'endTime',
					type: 'time',
					width: 150
				},  {
					label: 'baoyangpingjia',
					prop: 'remark'
				}, {	
					label: 'chuangjianren',
					prop: 'createBy'
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					width: 150
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 160,
					fixed: 'right'
				}],
				ids: ''
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
          orderBy:'createTime desc',
          mouldId: this.$attrs.maintenanceRecord.mould.id,
				}
				//设置默认时间查询条件
				this.setDefaultTime();
				this.yt.get(1);
				this.utils.event_hub.$on('BASE_MAINTENANCE_REFRESH', () => {
					this.yt.get();
				})
			}, 300)
		},
		watch: {
			'yt.editObj.action': {
				handler(n) {
					if (n === 'xinzeng') {
						this.$set(this.yt.editObj, 'itemList', [{
							part: '',
							content: '',
							attention: ''
						}])
					}
				},
				immediate: false,
				deep: true
			}
		},
		methods: {
			reset(){
				this.setDefaultTime();
				this.yt.get(1);
			},
			addItem() {
				this.yt.editObj.itemList.push({
					part: '',
					content: '',
					attention: ''
				})
			},
			deleteItem(key) {
				this.yt.editObj.itemList = this.yt.editObj.itemList.filter((item, index) => {
					return index !== key
				})
			},
			setQueryParams(){
				this.yt.conditions.equipmentId = this.$attrs.maintenanceRecord.equipmentId
			},
			setDefaultTime(){
				var currentMonthDate = new Date();
				currentMonthDate.setMonth(0)
				currentMonthDate.setDate(1);
				currentMonthDate.setHours(0);
				currentMonthDate.setSeconds(0);
				currentMonthDate.setMinutes(0);
				currentMonthDate.setMilliseconds(0);
				this.yt.conditions.year = currentMonthDate.getTime();
			}
		},
		
	};
</script>
